export default __webpack_public_path__ + "static/media/october-2019.fe89586f.csv";